import Service from "../../Service";
import Axios from "../../Config/API";
import {
    IConfigEnvelope,
    ICriarConfigEnvelope,
} from "../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeInterfaces";
import { ICreateResponse } from "../../../Interfaces/Utils/ResponseInterfaces";

export async function ListarConfigEnvelopeService(idProduto: number) {
    return Service(
        Axios.get<Array<IConfigEnvelope>>(
            `/home/configenvelope/listarconfigenvelope?idProduto=${idProduto}`
        )
    );
}

export async function GetConfigEnvelopeService(idConfigEnvelope: number) {
    return Service(
        Axios.get<IConfigEnvelope>(
            `/home/configenvelope/getconfigenvelope?idConfigEnvelope=${idConfigEnvelope}`
        )
    );
}

export async function CriarConfigEnvelopeService(
    configEnvelope: ICriarConfigEnvelope
) {
    return Service(
        Axios.post<ICreateResponse>(
            `/home/configenvelope/insereconfigenvelope`,
            configEnvelope
        )
    );
}

export async function DeletarConfigEnvelopeService(idConfigEnvelope: number) {
    return Service(
        Axios.delete<ICreateResponse>(
            `/home/configenvelope/deletaconfigenvelope?idConfigEnvelope=${idConfigEnvelope}`
        )
    );
}

export async function AtualizarConfigEnvelopeService(
    configEnvelope: IConfigEnvelope
) {
    return Service(
        Axios.put<ICreateResponse>(
            `/home/configenvelope/atualizaconfigenvelope`,
            configEnvelope
        )
    );
}
